module.exports = __webpack_public_path__ + "img/bidirektoral.79585103.svg";